module.exports = __webpack_public_path__ + "market/static/img/giftVer2.0e68600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/giftVer2.png
// module id = lkEU
// module chunks = 1